// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import { loadConversations } from "src/actions/auth";
import { logout } from "src/actions";

import {
  ParaLink,
  ParaContainer,
  ParaHeader,
  ParaFooter,
} from "src/styles/signup";
import FormContainerWithLogo from "src/components/auth/FormContainerWithLogo";

type Props = {
  loadConversations: Function,
  logout: Function,
};

const OfflineScreen = ({ loadConversations, logout }: Props) => (
  <FormContainerWithLogo>
    <ParaContainer>
      <ParaHeader>{i18n.t(k.NETWORK_ERROR_LOOKS_LIKE_YOU)}</ParaHeader>
      <ParaFooter>
        <ParaLink onClick={() => loadConversations()}>
          {i18n.t(k.CLICK_HERE_TO_TRY_AGAIN)}
        </ParaLink>
      </ParaFooter>
      <ParaFooter>
        <ParaLink onClick={() => logout()}>{i18n.t(k.CANCEL)}</ParaLink>
      </ParaFooter>
    </ParaContainer>
  </FormContainerWithLogo>
);

export default connect(null, { loadConversations, logout })(OfflineScreen);
